import React, { useState } from 'react';
import { Elements, StripeProvider } from 'react-stripe-elements';

import type { TSource } from '@feathr/blackbox';
import { Radios } from '@feathr/components';

import BankAccountInput from './BankAccountInput';
import CreditCardInput from './CreditCardInput';

type TPaymentType = 'ach' | 'credit';

interface IProps {
  onClose: () => void;
  onSave: (source: TSource) => Promise<void>;
}

function PaymentMethodForm({ onClose, onSave }: IProps) {
  const [paymentType, setPaymentType] = useState<TPaymentType>('credit');

  function handlePaymentTypeChange(newValue?: string) {
    setPaymentType(newValue as TPaymentType);
  }

  return (
    <>
      <Radios
        label={'Payment type'}
        onChange={handlePaymentTypeChange}
        options={[
          { id: 'credit', name: 'Credit card' },
          { id: 'ach', name: 'Bank account (ACH)' },
        ]}
        value={paymentType}
      />
      <StripeProvider apiKey={STRIPE_API_KEY}>
        <Elements>
          <>
            {paymentType === 'credit' && <CreditCardInput onClose={onClose} onSave={onSave} />}
            {paymentType === 'ach' && <BankAccountInput onClose={onClose} onSave={onSave} />}
          </>
        </Elements>
      </StripeProvider>
    </>
  );
}

export default PaymentMethodForm;
